export default __webpack_public_path__ + "static/media/tl-politics.39c20bf0.png";